// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('babel-core/register')
require('babel-polyfill')

import Vue from 'vue'
import App from './App'
import router from './router'
import directives from './api/directives'
import './assets/styles/sign/index.less'

Object.keys(directives).map(item => {
    Vue.directive([item], directives[item])
})
router.afterEach((to, from) => {
    window._za && window._za.pushData() // ilog pv uv 统计
})

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js